import React from 'react';
import { useOutletContext } from 'react-router-dom';
import { buildElevesBasicInfos } from '../LivretEval/buildElevesBasicInfos';
import { Eleve } from 'types/eleves';
import { LivretEval, Periode } from 'containers/Livrets/types/livret';
import { Bo } from 'types/bo';
import { NarrowContainer } from 'components/Container';
import { Contact, School } from 'types/school';
import { Schoolyear } from 'types/schoolyear';
import { Classroom } from 'types/classroom';
import { TryTeetshHeader } from 'components/TryTeetshHeader';
import { useTranslation } from 'react-i18next';
import { LivretEvalTable } from '../LivretEval/LivretEvalTable';

export function LivretEvalShare() {
  const context = useOutletContext<{
    school: School;
    schoolyear: Schoolyear;
    livretEval: LivretEval;
    periodes: Periode[];
    directors: Contact[];
    classroom: Classroom;
    eleves: Eleve[];
    bo: Bo;
    userId: string;
    token: string;
    readonly: boolean;
  }>();
  const { eleves, livretEval } = context;
  const { t } = useTranslation(['carnet', 'common']);

  return (
    <div>
      <TryTeetshHeader
        utmCampaign="share_livret_eval"
        title={t('carnet:livret.livrets')}
      />
      <NarrowContainer width="6xl">
        <LivretEvalTable
          readonly={context?.readonly as boolean}
          getEleveLink={eleveId =>
            `/shares/${context.userId}/t/${context.token}/livrets/eleves/${eleveId}`
          }
          livretEval={context?.livretEval as LivretEval}
          eleves={buildElevesBasicInfos(eleves, livretEval)}
        />
      </NarrowContainer>
    </div>
  );
}
